import React from "react";
import { localize } from "redux-i18n";

class NotificationTypeExposure extends React.Component {
  get typesInfo() {
    return {
      BASIC_NOTIFICATION: {
        explanationText: "BASIC_NOTIFICATION_TYPE_EXPLANATION",
        riskColor: "bg-mint",
        riskLevel: "LOW",
      },
      STANDARD_NOTIFICATION: {
        explanationText: "STANDART_NOTIFICATION_TYPE_EXPLANATION",
        riskColor: "bg-coffee",
        riskLevel: "MEDIUM",
      },
      FULL_NOTIFICATION: {
        explanationText: "FULL_NOTIFICATION_TYPE_EXPLANATION",
        riskColor: "bg-rose",
        riskLevel: "HIGH",
      },
    };
  }

  get currentTypeInfo() {
    return this.props.currentType && this.typesInfo[this.props.currentType];
  }

  render() {
    if (!this.props.currentType) {
      return null;
    }

    return (
      <div className="mb-3">
        <div className="d-flex align-items-center font-weight-bold fs-18">
          {this.props.t("DATA_EXPOSURE_INDEX")}
          <div className={`status-badge pill ml-3 ${this.currentTypeInfo.riskColor}`}>
            {this.props.t(this.currentTypeInfo.riskLevel)}
          </div>
        </div>
        <div className="d-flex mt-2">
          <div className="w-25 mr-3">
            <div className="d-flex justify-content-between">
              {this.props.t("ABSENCE_DETAILS")}:<span className="material-icons">done</span>
            </div>
            <div className="d-flex justify-content-between">
              {this.props.t("ABSENCE_REASONS")}:
              {this.props.currentType === "BASIC_NOTIFICATION" ? (
                <span className="material-icons text-color-danger">close</span>
              ) : (
                <span className="material-icons">done</span>
              )}
            </div>
            <div className="d-flex justify-content-between">
              {this.props.t("RTW_INTERVIEWS")}:
              {this.props.currentType === "FULL_NOTIFICATION" ? (
                <span className="material-icons">done</span>
              ) : (
                <span className="material-icons text-color-danger">close</span>
              )}
            </div>
            <div className="d-flex justify-content-between">
              {this.props.t("RECORD_ACCESS")}:
              {this.props.currentType === "FULL_NOTIFICATION" ? (
                <span className="material-icons">done</span>
              ) : (
                <span className="material-icons text-color-danger">close</span>
              )}
            </div>
          </div>
          <div
            className={`w-75 p-2 fs-12 borders-solid-color-grey ${this.currentTypeInfo.riskColor}`}
          >
            {this.props.t(this.currentTypeInfo.explanationText)}
          </div>
        </div>
      </div>
    );
  }
}

export default localize()(NotificationTypeExposure);
